import { Box, Grid, useMediaQuery, useTheme } from "@material-ui/core";
import React from "react";
import SingleItem from "../LandingPageFeature/LandingPageFeature";
import secure from "../../../assets/staticAssets/01.svg";
import support from "../../../assets/staticAssets/02.svg";
import charges from "../../../assets/staticAssets/03.svg";
import { makeStyles } from "@material-ui/styles";
import TransparentFlexBox from "../TransparentFlexBox/TransparentFlexBox";
import EndCredits from "../EndCredits/EndCredits";
import earn from "../../../assets/staticAssets/earn_2.svg";
import googleplay from "../../../assets/staticAssets/googleplay.png";
import Img from "react-cool-img";

function LandingPageSeventhSection() {
  const classes = useStyles();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("md"));
  const sm_matches = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <>
      <div className="relative pb-10 mb:pb-0">
        {" "}
        <Img
          className="absolute right-0 bottom-44 opacity-50 z-0"
          src={require("../../../assets/svgs/background-dots.svg").default}
        />
        <div className="container-bt">
          <div className="flex justify-between flex-wrap items-center md:-mt-20">
            <div className="md:w-[50%] leading-relaxed ">
              <h1 className="font-extrabold mb-10">
                Start Trading today <br className="md:block hidden"></br>with{" "}
                <span className="text-pb-primary-100">PocketBits</span>
              </h1>
              <span style={{ color: "#ccc" }}>
                <div className="flex justify-center">
                  <Img
                    className="w-3/4 -mt-20 -mb-16 md:hidden"
                    src={
                      require("../../../assets/optimized/Landing/Start Trading Section/startTradingSectionImage2x.png")
                        .default
                    }
                  />
                </div>
                <div className="flex items-center gap-x-5 md:gap-x-10  mb-5">
                  <div className="flex items-center md:w-1/2">
                    <div className="mr-3">
                      <Img
                        src={
                          require("../../../assets/optimized/Landing/Start Trading Section/no account charges-icon.svg")
                            .default
                        }
                      />
                    </div>
                    <h4 className="font-normal">
                      No Account <br className="md:block hidden"></br> Charges
                    </h4>
                  </div>{" "}
                  <div className="flex items-center md:w-1/2">
                    <div className="mr-3">
                      <Img
                        className=" "
                        src={
                          require("../../../assets/optimized/Landing/Start Trading Section/trade-in-inr.svg")
                            .default
                        }
                      />
                    </div>
                    <h4 className="font-normal">Trade Directly in INR</h4>
                  </div>
                </div>
                <div className="flex items-center gap-x-5 md:gap-x-10 mb-5">
                  <div className="flex items-center md:w-1/2">
                    <div className="mr-3">
                      <Img
                        src={
                          require("../../../assets/optimized/Landing/Start Trading Section/Hack-free.svg")
                            .default
                        }
                      />
                    </div>
                    <h4 className="font-normal">
                      Hack Free operations since 2017
                    </h4>
                  </div>{" "}
                  <div className="flex items-center md:w-1/2">
                    <div className="mr-3">
                      <Img
                        // className=" w-[60px] h-[60px] "
                        src={
                          require("../../../assets/optimized/Landing/Start Trading Section/inr-depo-withdrawals.svg")
                            .default
                        }
                      />
                    </div>
                    <h4 className="font-normal">
                      Realtime INR Deposits & Withdrawals
                    </h4>
                  </div>
                </div>
                <div className="flex items-center gap-x-5 md:gap-x-10 mb-5">
                  <div className="flex items-center md:w-1/2">
                    <div className="mr-3">
                      <Img
                        src={
                          require("../../../assets/optimized/Landing/Start Trading Section/chat-support.svg")
                            .default
                        }
                      />
                    </div>
                    <h4 className="font-normal">24/7 Human Chat Support</h4>
                  </div>{" "}
                  <div className="flex items-center md:w-1/2">
                    <div className="mr-3">
                      <Img
                        src={
                          require("../../../assets/optimized/Landing/Start Trading Section/round-the-clock.svg")
                            .default
                        }
                      />
                    </div>
                    <h4 className="font-normal">
                      Round the clock KYC Verification
                    </h4>
                  </div>
                </div>
              </span>
            </div>

            <div className="md:w-[50%] hidden md:block">
              <Img
                className=" md:max-w-[500px] w-full "
                src={
                  require("../../../assets/optimized/Landing/Start Trading Section/startTradingSectionImage2x.png")
                    .default
                }
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

const useStyles = makeStyles((theme) => ({}));

export default LandingPageSeventhSection;
